import { render, staticRenderFns } from "./ListRadio.vue?vue&type=template&id=484e14ef&scoped=true&"
import script from "./ListRadio.vue?vue&type=script&lang=js&"
export * from "./ListRadio.vue?vue&type=script&lang=js&"
import style0 from "./ListRadio.vue?vue&type=style&index=0&id=484e14ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484e14ef",
  null
  
)

export default component.exports